module.exports = __webpack_public_path__ + "static/media/glass7.46449086.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/glass7.png
// module id = 732
// module chunks = 0